import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { ReactComponent as CheckIcon } from "assets/icons/new/check.svg";

const mainClass = "status-pill";

const StatusPill = ({ active, onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      className={classnames(mainClass, { [`${mainClass}--active`]: active })}
      type="button"
      onClick={onClick}
    >
      <i>
        <CheckIcon />
      </i>
      <span>{t(active ? "Read" : "Unread")}</span>
    </button>
  );
};

export default StatusPill;
